import BrandsSubscriptionsStore from '../store/schema/BrandsSubscriptionsStore';
import getStore from '../store/store';
import { mutator } from 'satcheljs';
import { onUnsubscribeFromBrand, loadBrandsSubscriptions } from '../actions/internalActions';

export default mutator(onUnsubscribeFromBrand, actionMessage => {
    const brandsSubscriptionsStore: BrandsSubscriptionsStore = getStore();
    let itemIndex;
    const [item] = brandsSubscriptionsStore.subscriptions.filter((elem, index) => {
        if (
            elem &&
            elem.smtpInfo &&
            elem.smtpInfo.smtpIdentifier === actionMessage.smtpIdentifier
        ) {
            itemIndex = index;
            return true;
        }
        return false;
    });

    if (item) {
        brandsSubscriptionsStore.subscriptions.splice(itemIndex, 1);
        brandsSubscriptionsStore.unsubscribedSubscriptions.push(item);
        brandsSubscriptionsStore.unsubscribedSubscriptions = brandsSubscriptionsStore.unsubscribedSubscriptions.sort(
            (sub1, sub2) => {
                // It seems that there some subscriptions that are null, so make sub1 < than sub 2 if sub 1 is null
                if (!sub1 || !sub1.smtpInfo) {
                    return -1;
                }

                // It seems that there some subscriptions that are null, so make sub2 < than sub 1 if sub 2 is null
                if (!sub2 || !sub2.smtpInfo) {
                    return 1;
                }

                // if the are both valid, just compare based on display name
                return sub1.smtpInfo.displayName.localeCompare(sub2.smtpInfo.displayName);
            }
        );
    } else {
        // If there for some reason the item was not found, then reload
        loadBrandsSubscriptions();
    }
});
